import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensProvidersSummaries} from './citizens-providers-summaries.model';
import * as CitizensProvidersSummariesActions from './citizens-providers-summaries.actions';

export const citizensProvidersSummariesesFeatureKey = 'citizensProvidersSummarieses';

export interface State extends EntityState<CitizensProvidersSummaries> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensProvidersSummaries> = createEntityAdapter<CitizensProvidersSummaries>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensProvidersSummariesActions.addCitizensProvidersSummaries,
    (state, action) => adapter.addOne(action.citizensProvidersSummaries, state)
  ),
  on(CitizensProvidersSummariesActions.upsertCitizensProvidersSummaries,
    (state, action) => adapter.upsertOne(action.citizensProvidersSummaries, state)
  ),
  on(CitizensProvidersSummariesActions.addCitizensProvidersSummariess,
    (state, action) => adapter.addMany(action.citizensProvidersSummariess, state)
  ),
  on(CitizensProvidersSummariesActions.upsertCitizensProvidersSummariess,
    (state, action) => adapter.upsertMany(action.citizensProvidersSummariess, state)
  ),
  on(CitizensProvidersSummariesActions.updateCitizensProvidersSummaries,
    (state, action) => adapter.updateOne(action.citizensProvidersSummaries, state)
  ),
  on(CitizensProvidersSummariesActions.updateCitizensProvidersSummariess,
    (state, action) => adapter.updateMany(action.citizensProvidersSummariess, state)
  ),
  on(CitizensProvidersSummariesActions.deleteCitizensProvidersSummaries,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensProvidersSummariesActions.deleteCitizensProvidersSummariess,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensProvidersSummariesActions.loadCitizensProvidersSummariess,
    (state, action) => adapter.setAll(action.citizensProvidersSummariess, state)
  ),
  on(CitizensProvidersSummariesActions.clearCitizensProvidersSummariess,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
